module.exports = __webpack_public_path__ + "assets/media/day27.bc314b0e.mp3";